import { HalResource } from '../hal/models/HalResource';
import { EmbeddedCollection } from './EmbeddedCollection';
/**
 * Filter details
 */
export class SearchIndexTopFiltersNoResultSearchValue {
}
/**
 * Class representing searches with no results for an Algolia Search Index
 */
export class SearchIndexTopFiltersNoResultSearch extends HalResource {
}
/**
 * @hidden
 */
export class SearchIndexTopFiltersNoResultSearchCollection extends EmbeddedCollection {
    constructor(data) {
        super('top-filters-no-result-search', SearchIndexTopFiltersNoResultSearch, data);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VhcmNoSW5kZXhUb3BGaWx0ZXJzTm9SZXN1bHRTZWFyY2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21vZGVsL1NlYXJjaEluZGV4VG9wRmlsdGVyc05vUmVzdWx0U2VhcmNoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSwyQkFBMkIsQ0FBQztBQUN4RCxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUUxRDs7R0FFRztBQUNILE1BQU0sT0FBTyx3Q0FBd0M7Q0FlcEQ7QUFFRDs7R0FFRztBQUNILE1BQU0sT0FBTyxtQ0FBb0MsU0FBUSxXQUFXO0NBVW5FO0FBQ0Q7O0dBRUc7QUFDSCxNQUFNLE9BQU8sNkNBQThDLFNBQVEsa0JBRWxFO0lBQ0MsWUFBWSxJQUFVO1FBQ3BCLEtBQUssQ0FDSCw4QkFBOEIsRUFDOUIsbUNBQW1DLEVBQ25DLElBQUksQ0FDTCxDQUFDO0lBQ0osQ0FBQztDQUNGIn0=